import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useRef, useState } from "react";
import Slider from "react-slick";
import H2Font from "../../common/H2Font";
import { allRdsData } from "../data";
import BioDrawer from "../YourRD/BioDrawer";
import { NextRoundedArrow, PrevRoundedArrow } from "./controls";
import ExploreAllTeamCard from "./ExploreAllTeamCard";
import ExploreTeamCard from "./ExploreTeamCard";
import styles from "./styles.module.scss";
const ExploreTeam = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const sliderRef = useRef(null);
    const toggleDrawer = (value) => () => {
        setOpenDrawer(value);
    };
    const [currentRd, setCurrentRd] = useState("");
    const showDrawer = (name) => {
        setCurrentRd(name);
        setOpenDrawer(true);
    };
    const getRdData = allRdsData.find((item) => item.name.toLowerCase() === currentRd);
    const settings = {
        slidesToShow: 3,
        dots: true,
        arrows: true,
        infinite: true,
        initialSlide: 1,
        centerMode: true,
        centerPadding: "0px",
        nextArrow: _jsx(NextRoundedArrow, {}),
        prevArrow: _jsx(PrevRoundedArrow, {}),
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "40px",
                    arrows: false,
                },
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    centerMode: false,
                },
            },
        ],
    };
    const assignSlider = (slider) => {
        sliderRef.current = slider;
    };
    const nextSlide = () => {
        sliderRef?.current?.slickNext();
    };
    return (_jsxs("div", { className: styles.explore_team, children: [_jsx(H2Font, { children: "Meet The Team That\u2019s Here To Support Your Goals." }), _jsx(Slider, { ...settings, className: styles.carousel, ref: (slider) => assignSlider(slider), children: allRdsData.map((item, i) => i === 1 ? (_jsx(ExploreAllTeamCard, { nextSlide: () => nextSlide() }, "all")) : (_jsx(ExploreTeamCard, { ...item, showBio: (name) => showDrawer(name) }, item.name))) }), _jsx(BioDrawer, { openDrawer: openDrawer, toggleDrawer: toggleDrawer, ...getRdData })] }));
};
export default ExploreTeam;
